import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import dataProvider from "../../services/DataProvider";

import Navigation from "../../components/Navigation";

import FormExterno from "../../components/FormExterno";

const PaineisControle = () => {

    const [src, setSrc] = useState([])

    useEffect(() => {

        dataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {

            if (typeof response.data.link_bi !== 'undefined') {
                setSrc(response.data.link_bi)
            }

        })

    }, []);

    return (
        <div style={{ minHeight: 600 }} id="div_iframe" >

            <Navigation titulo="Painel de controle"/>
            
           <FormExterno src={src}/>

        </div>
    )
}

export default PaineisControle;
